import { ApiUtility } from "../Utilities/ApiUtility.axios";

class DashboardService {
    route = `/API/Dashboard`;
    
    getPracticeStatsFinancialDetails = (fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/PracticeStatsFinancialDetails`, {fromDate,toDate})

    getSubmissionDetails = (practiceId:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/SubmissionDetails`,{practiceId,fromDate,toDate});

    getInvoiceDetails = (practiceId:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/InvoiceDetails`,{practiceId,fromDate,toDate})

    getPracticeUserDetails = (fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/PracticeUserDetails`,{fromDate,toDate})

    getUpdateDetails = (fromDate: string, toDate: string, start: number, length: number, sortCol: string, sortDir: string) =>   
        ApiUtility.get(`${this.route}/UpdateDetails`, { fromDate, toDate, start, length, sortDir, sortCol });

    getIncommingStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/IncommingStatsDetails`,{start,length,fromDate,toDate})

    getOutgoingStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/OutgoingStatsDetails`,{start,length,fromDate,toDate})

    getEmailStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/EmailStatsDetails`,{start,length,fromDate,toDate})

    getStorageStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/StorageStatsDetails`,{start,length,fromDate,toDate})

    getInvoiceStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/InvoiceStatsDetails`,{start,length,fromDate,toDate})

    getReceiptStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/ReceiptStatsDetails`,{start,length,fromDate,toDate})

    getStripeStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/StriptStatsDetails`,{start,length,fromDate,toDate})

    getGoCardLessStatsDetails = (start:number,length:number,fromDate:string,toDate:string) => ApiUtility.get(`${this.route}/GoCardLessStatsDetails`,{start,length,fromDate,toDate})
    
};

export default new DashboardService();